import createPersistedState from "vuex-persistedstate";

export default ({ store }) => {
  window.onNuxtReady(() => {
    createPersistedState({
      key: "exam", // this key which save in local storage
      paths: ["organization", "appPersisted"], // this path of your store
    })(store);
  });
};
